import {
  fetch,
  buildQueryString,
} from '../utils/request';

const PANELS_BASE = process.env.TAGBOARD_PANELS_URL;

/**
 * Fetch paginated list of panels from API.
 * @param {Number} owner - Owner of the panels.
 * @param {Object} [opts] - Additional opts to paginate/filter results.
 * @returns {Promise<Object>} API Response
 */
export const getPanels = (owner, opts = {}) => {
  const query = { ...opts, scope: 'producer', legacySearch: 'false' };
  return fetch(`${PANELS_BASE}/panels/${owner}${buildQueryString(query)}`);
};

export const getTags = (owner) => (
  fetch(`${PANELS_BASE}/panels/${owner}/tags`)
);

/**
 * Get list of panels by ID(s).
 * @param {Number} owner - ID of the owner of the panels.
 * @param {Array<String>} panelIds - List of panels to fetch.
 * @returns <Promise<Object>} API Response
 */
export const getMultiplePanels = (owner, panelIds = []) => {
  if (!panelIds.length) {
    return { panels: [] };
  }

  const query = {
    panels: panelIds.join(','),
  };

  return fetch(`${PANELS_BASE}/panels/${owner}/many${buildQueryString(query)}`);
};

/**
 * Duplicate an existing panel by ID.
 * @param {Object} panelId - ID of the panel to duplicate
 * @returns {Promise<Object>} API Response
 */
export const duplicatePanel = (panelId) => (
  fetch(`${PANELS_BASE}/panel/${panelId}/duplicate`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
  })
);
